import { render } from "./ControlTime.vue?vue&type=template&id=c6e21b52"
import script from "./ControlTime.vue?vue&type=script&lang=js"
export * from "./ControlTime.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__